"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SvgIcon_1 = require("./internal/SvgIcon");

exports.User = function (props) {
  return react_1.default.createElement(SvgIcon_1.SvgIcon, tslib_1.__assign({}, props), react_1.default.createElement("svg", {
    viewBox: "0 0 16 16"
  }, react_1.default.createElement("path", {
    fillRule: "evenodd",
    d: "M3.00937 12.999C2.70858 12.999 2.46705 12.9079 2.28476 12.7256C2.10247 12.5433 2.00904 12.3018 2.00449 12.001V10.9961L2.33945 10.9141C3.76132 10.5312 4.98266 9.89323 6.00349 9V8.00195C5.70271 7.79687 5.46118 7.51205 5.27889 7.14746C5.0966 6.78288 5.00545 6.40007 5.00545 5.99902V4.50195C5.00545 3.80013 5.24698 3.20768 5.73006 2.72461C6.21313 2.24153 6.80557 2 7.50739 2C8.20922 2 8.80166 2.24153 9.28473 2.72461C9.76781 3.20768 10.0093 3.80013 10.0093 4.50195V5.99902C10.0048 6.40007 9.91136 6.78288 9.72907 7.14746C9.54677 7.51205 9.30524 7.79687 9.00446 8.00195V9L9.23688 9.18457C10.203 10.0049 11.4585 10.6087 13.0035 10.9961V12.001C13.0035 12.3018 12.9123 12.5433 12.73 12.7256C12.5477 12.9079 12.3062 12.999 12.0054 12.999H3.00937Z",
    clipRule: "evenodd"
  })));
};